import responseStatusFormatter from '../../../components/valueFormatter/responseStatusFormatter';
import userStatusFormatter from '../../../components/valueFormatter/userStatusFormatter';
import dateFormatter from '../../../components/valueFormatter/dateFormatter';
import responseStatusFilterValueGetter from '../../../components/filterValueGetter/responseStatusFilterValueGetter';
import userStatusFilterValueGetter from '../../../components/filterValueGetter/userStatusFilterValueGetter';
import dateFilterComparator from '../../../utils/ag-grid/dateFilterComparator';
import type { ColDef } from 'ag-grid-community';
import type { TFunction } from 'i18next';

const useColdefInventoryStatus = (t: TFunction<'translation', undefined>) => {
  const colDefs: ColDef[] = [
    {
      field: 'jobId',
      headerName: t('inventory.id'),
      headerTooltip: t('inventory.id'),
      minWidth: 70,
      maxWidth: 70,
    },
    {
      field: 'organizationName',
      headerName: t('organization.organization'),
      headerTooltip: t('organization.organization'),
      tooltipField: 'organizationName',
      minWidth: 100,
      // maxWidth: 100,
    },
    {
      field: 'userName',
      headerName: t('user.name'),
      headerTooltip: t('user.name'),
      minWidth: 100,
    },
    {
      field: 'email',
      headerName: t('user.email'),
      headerTooltip: t('user.email'),
      minWidth: 100,
    },
    {
      field: 'firstMailDate',
      headerName: t('inventory.initialContactDate'),
      headerTooltip: t('inventory.initialContactDate'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateFormatter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'secondMailDate',
      headerName: t('inventory.secondContactDate'),
      headerTooltip: t('inventory.secondContactDate'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateFormatter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'responseDate',
      headerName: t('inventory.responseDate'),
      headerTooltip: t('inventory.responseDate'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateFormatter,
      minWidth: 105,
      maxWidth: 105,
    },
    {
      field: 'responseStatus',
      headerName: t('inventory.responseStatus'),
      headerTooltip: t('inventory.responseStatus'),
      valueFormatter: responseStatusFormatter,
      filterValueGetter: responseStatusFilterValueGetter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'lastDeleteDate',
      headerName: t('inventory.deletionDate'),
      headerTooltip: t('inventory.deletionDate'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateFormatter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'userStatus',
      headerName: t('inventory.userStatus'),
      headerTooltip: t('inventory.userStatus'),
      valueFormatter: userStatusFormatter,
      filterValueGetter: userStatusFilterValueGetter,
      minWidth: 130,
      maxWidth: 130,
    },
  ];

  return colDefs;
};

export default useColdefInventoryStatus;
